export const useUserRouterStore = defineStore('user-router-store', {
  state: () => ({
    routerIsReady: false
  }),
  actions: {
    setRouterIsReady(isReady) {
      this.routerIsReady = isReady;
    }
  }
});